import { lazyWithRetry } from '@/lib/lazy-with-retry';
import Index from '@/pages/Index';
import { useSiteSetting } from '@/hooks/useSiteSettings';
import { isLaunchEnabled } from '@/lib/launch-consent';
const ComingSoon=lazyWithRetry(()=>import('@/pages/ComingSoon'));
export function LaunchHome(){const {data,isLoading}=useSiteSetting('launch_campaign_enabled');if(isLoading)return <div className="min-h-screen bg-background"/>;return isLaunchEnabled(data)?<ComingSoon/>:<Index/>;}
